module.exports = __webpack_public_path__ + "static/media/11.782be26a.jpeg";